import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStep5 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 537 400",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M483.264 369.413H447.747V369.681H483.264V369.413Z",
					fill: "#EBEBEB"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M355.993 372.329H346.674V372.597H355.993V372.329Z",
					fill: "#EBEBEB"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M446.675 359.461H426.096V359.729H446.675V359.461Z",
					fill: "#EBEBEB"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M103.372 361.262H57.0552V361.531H103.372V361.262Z",
					fill: "#EBEBEB"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M119.715 361.262H112.927V361.531H119.715V361.262Z",
					fill: "#EBEBEB"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M242.246 365.788H141.785V366.056H242.246V365.788Z",
					fill: "#EBEBEB"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M536.991 352.158H0.797852V352.426H536.991V352.158Z",
					fill: "#EBEBEB"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M81.9348 100.791H179.19C191.651 100.791 194.653 83.3535 182.889 79.257L182.428 79.1069C195.447 68.2543 166.889 45.3911 135.865 77.0479C138.289 66.4956 110.707 70.3133 102.278 84.7155C99.2753 75.257 72.9804 91.686 81.9348 100.791Z",
					fill: "#F0F4FE"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M342.063 57.3053H400.38C400.38 57.3053 414.053 52.1578 412.283 38.5171C410.514 24.8763 389.87 36.2436 389.87 36.2436C389.87 36.2436 396.122 17.2088 376.133 22.6136C356.144 28.0184 354.192 46.8817 354.192 46.8817C354.192 46.8817 327.929 42.2919 342.063 57.3053Z",
					fill: "#F0F4FE"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M395.64 95.6753H434.139C434.139 95.6753 443.168 92.2759 441.999 83.2678C440.83 74.2598 427.2 81.7665 427.2 81.7665C427.2 81.7665 431.329 69.2088 418.128 72.7692C414.407 73.72 411.048 75.7471 408.473 78.5968C405.898 81.4466 404.221 84.9924 403.651 88.7906C403.651 88.7906 386.31 85.7772 395.64 95.6753Z",
					fill: "#F0F4FE"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M388.24 290.828L388.133 279.439V278.807L388.037 268.651V268.008L387.94 258.356V257.723L387.854 248.533V247.933L387.769 239.16V238.603L387.683 230.217V229.691L387.608 221.681V221.166L387.543 214.538C387.208 214.75 386.848 214.919 386.471 215.042V220.64H379.372L385.098 215.396C384.508 215.515 383.909 215.586 383.307 215.611L378.589 219.9L378.675 214.839C378.285 214.683 377.923 214.465 377.602 214.195L377.474 221.144V221.659L377.345 229.67V230.217L377.184 238.571V239.128L377.034 247.879V248.479L376.873 257.67V258.303L376.702 267.954V268.608L376.519 278.753V279.439L376.326 290.817L375.232 339.933L388.916 340.093L388.24 290.828ZM386.814 288.683L378.568 279.772H386.761L386.814 288.683ZM386.685 278.71H378.525L386.621 270.195L386.685 278.71ZM386.771 266.195L378.921 258.152H386.728L386.771 266.195ZM386.675 257.048H378.911L386.632 249.316L386.675 257.048ZM386.621 246.399L379.114 239.096H386.557L386.621 246.399ZM386.621 237.959H379.2L386.557 230.903L386.621 237.959ZM386.492 221.713V228.394L379.34 221.745L386.492 221.713ZM378.428 223.236L385.581 229.906H378.332L378.428 223.236ZM378.321 231.064H385.57L378.16 238.056L378.321 231.064ZM378.171 240.833L385.677 248.147H378.106L378.171 240.833ZM378.064 249.262H385.667L377.956 256.962L378.064 249.262ZM377.913 259.911L385.774 267.986H377.806L377.913 259.911ZM377.838 269.069H385.785L377.677 277.541L377.838 269.069ZM377.785 280.286L386.031 289.23H377.656L377.785 280.286Z",
					fill: "#EBEBEB"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M387.425 213.327H386.879L386.482 212.962L383.265 215.965C383.862 215.936 384.457 215.864 385.045 215.75L386.385 214.528V215.354C386.761 215.227 387.12 215.058 387.458 214.85L387.425 213.327ZM377.495 213.391V214.592C377.823 214.853 378.183 215.069 378.568 215.236V213.391H377.495Z",
					fill: "#EBEBEB"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M389.002 212.437C389.04 212.734 389.009 213.036 388.91 213.319C388.811 213.602 388.648 213.858 388.433 214.067L388.047 214.431C387.844 214.594 387.629 214.741 387.404 214.871C387.067 215.079 386.707 215.248 386.332 215.375C385.899 215.55 385.45 215.683 384.991 215.772C384.404 215.885 383.809 215.957 383.211 215.986H382.407C381.092 215.989 379.79 215.726 378.578 215.214C378.194 215.048 377.833 214.831 377.506 214.571L377.409 214.496L377.055 214.152C376.848 213.951 376.693 213.702 376.603 213.428C376.514 213.153 376.492 212.861 376.541 212.576L377.356 208.008H375.211L382.718 204.201L390.535 207.761H388.337L389.002 212.437Z",
					fill: "#EBEBEB"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M423.447 218.163L423.736 339.954H432.573H483.94H492.777L493.163 218.163H423.447Z",
					fill: "#EBEBEB"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M436.927 202.667L436.959 229.82H442.428H474.224H479.694L479.747 202.667H436.927Z",
					fill: "#EBEBEB"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M436.873 229.82H427.843L427.833 221.691H436.862L436.873 229.82Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M454.192 221.681H445.163V229.82H454.192V221.681Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M471.522 221.681H462.492V229.82H471.522V221.681Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M488.841 229.82H479.812L479.833 221.691H488.862L488.841 229.82Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M436.755 244.651H427.94L427.918 236.716H436.744L436.755 244.651Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M454.053 236.716H445.227V244.651H454.053V236.716Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M471.361 236.716H462.535V244.651H471.361V236.716Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M488.648 244.651H479.822L479.843 236.716H488.669L488.648 244.651Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M436.68 259.107H428.069L428.047 251.364H436.669L436.68 259.107Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M453.967 251.364H445.345V259.107H453.967V251.364Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M471.243 251.364H462.621V259.107H471.243V251.364Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M454.139 209.874H444.938V218.174H454.139V209.874Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M471.49 209.874H462.278V218.174H471.49V209.874Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M488.508 259.107H479.897L479.908 251.364H488.53L488.508 259.107Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M436.658 273.23H428.24L428.219 265.67H436.648L436.658 273.23Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M453.913 265.67H445.495V273.23H453.913V265.67Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M471.178 273.23H462.76L462.771 265.67H471.189L471.178 273.23Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M488.433 273.23H480.015L480.037 265.67H488.455L488.433 273.23Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M437.034 289.102H427.65L427.629 280.683H437.023L437.034 289.102Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M454.256 289.102H444.884L444.873 280.683H454.267L454.256 289.102Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M471.489 289.102H462.106V280.683H471.5L471.489 289.102Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M488.712 289.102H479.329L479.35 280.683H488.733L488.712 289.102Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M437.087 302.507H427.918L427.897 294.292H437.077L437.087 302.507Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M454.299 294.292H445.13V302.507H454.299V294.292Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M471.533 294.292H462.364V302.507H471.533V294.292Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M488.744 302.507H479.575L479.597 294.292H488.776L488.744 302.507Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M436.894 317.595H427.951L427.94 309.595H436.884L436.894 317.595Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M454.085 309.595H445.141V317.595H454.085V309.595Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M471.275 309.595H462.332V317.595H471.275V309.595Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M488.454 317.595H479.521L479.532 309.595H488.476L488.454 317.595Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M436.894 331.311H428.165L428.154 323.514H436.883L436.894 331.311Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M488.423 331.311H479.704L479.715 323.514H488.444L488.423 331.311Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M471.318 323.514H445.259L445.312 325.477H446.031L446.042 339.954H448.648L448.637 325.477H467.983L467.961 339.954H470.567L470.589 325.477H471.371L471.318 323.514Z",
					fill: "#F5F5F5"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M458.417 339.954H448.766V325.477H458.428L458.417 339.954Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M467.843 339.954H458.181L458.192 325.477H467.865L467.843 339.954Z",
					fill: "#EBEBEB"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M423.543 256.908L423.736 339.954H412.659H348.251H337.163L336.369 256.908H423.543Z",
					fill: "#F5F5F5"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M406.975 275.364H417.784L417.752 265.67H406.942L406.975 275.364Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M385.409 275.364H396.219L396.176 265.67H385.355L385.409 275.364Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M363.844 275.364H374.653L374.589 265.67H363.779L363.844 275.364Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M342.278 275.364H353.087L353.002 265.67H342.192L342.278 275.364Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M406.567 294.292H418.213L418.181 283.858H406.524L406.567 294.292Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M385.044 294.292H396.69L396.637 283.858H384.98L385.044 294.292Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M363.511 294.292H375.157L375.093 283.858H363.436L363.511 294.292Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M341.988 294.292H353.634L353.548 283.858H341.892L341.988 294.292Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M406.868 311.6H418.171L418.149 301.488H406.835L406.868 311.6Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M385.366 311.6H396.669L396.626 301.488H385.312L385.366 311.6Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M363.865 311.6H375.168L375.104 301.488H363.79L363.865 311.6Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M342.353 311.6H353.656L353.581 301.488H342.267L342.353 311.6Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M407.114 329.37H418.074L418.053 319.568H407.071L407.114 329.37Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M342.685 329.37H353.656L353.57 319.568H342.6L342.685 329.37Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M363.35 319.568H397.27L397.28 322.528H395.114L395.2 339.954H392.058L391.972 322.528H368.701L368.819 339.954H365.688L365.559 322.528H363.382L363.35 319.568Z",
					fill: "#F5F5F5"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M380.519 339.954H392.133L392.047 322.528H380.412L380.519 339.954Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M368.744 339.954H380.358L380.262 322.528H368.626L368.744 339.954Z",
					fill: "#EBEBEB"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M163.908 185.82V181.917C163.891 181.805 163.834 181.703 163.749 181.63C163.663 181.556 163.554 181.516 163.441 181.516C163.328 181.516 163.219 181.556 163.134 181.63C163.048 181.703 162.992 181.805 162.975 181.917V186.206C162.98 186.328 163.03 186.443 163.115 186.53C163.2 186.618 163.314 186.67 163.436 186.678C163.807 186.678 164.171 186.788 164.48 186.995C164.788 187.202 165.029 187.495 165.171 187.839C165.312 188.182 165.349 188.56 165.276 188.925C165.202 189.289 165.022 189.623 164.759 189.885C164.495 190.147 164.16 190.325 163.795 190.397C163.431 190.468 163.053 190.429 162.71 190.285C162.367 190.142 162.075 189.899 161.87 189.589C161.665 189.279 161.557 188.916 161.559 188.544C161.559 187.954 160.573 187.954 160.626 188.544C160.862 190.871 163.575 192.404 165.42 190.539C165.774 190.173 166.022 189.719 166.137 189.223C166.253 188.728 166.232 188.211 166.077 187.726C165.922 187.242 165.638 186.809 165.256 186.473C164.874 186.137 164.408 185.912 163.908 185.82Z",
					fill: "#EBEBEB"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M95.168 157.756V166.206L86.2565 157.295L85.8168 157.734H85.1948V238.163H96.412V157.734L95.168 157.756ZM86.4388 219.118L94.2887 226.968H86.4388V219.118ZM86.4388 199.161L94.2887 207.01H86.4388V199.161ZM86.4388 179.214L94.2887 187.064H86.4388V179.214ZM86.4388 159.257L94.2887 167.118H86.4388V159.257ZM94.2887 168.351L86.4388 176.212V168.351H94.2887ZM95.168 169.23V177.091H87.3182L95.168 169.23ZM94.2887 188.308L86.4388 196.158V188.308H94.2887ZM95.168 189.187V197.037H87.3182L95.168 189.187ZM94.2887 208.254L86.4388 216.115V208.254H94.2887ZM95.168 209.102V216.962H87.3182L95.168 209.102ZM94.2887 228.179L86.4388 236.029V228.179H94.2887ZM87.3182 236.984L95.168 229.091V236.984H87.3182ZM95.168 226.088L87.3182 218.238H95.168V226.088ZM95.168 206.131L87.3182 198.281H95.168V206.131ZM95.168 186.185L87.3182 178.335H95.168V186.185Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M86.4385 131.268V146.903H87.661V140.93L94.0953 147.364L94.535 146.925H95.1677V131.268H86.4385ZM93.0229 132.512L87.661 137.874V132.512H93.0229ZM93.9023 145.38L88.5404 140.018H93.9023V145.38ZM88.5404 138.785L93.9023 133.423V138.785H88.5404Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M65.9559 157.756H50.9961V172.715H65.9559V157.756Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M163.64 179.343H162.803V150.581L93.1303 127.471H88.5297L51.2214 150.624L50.7817 149.927L88.2831 126.646H93.2697L93.334 126.667L163.64 149.981V179.343Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M155.114 158.41H155.972L164.723 149.659H50.374V158.378H155.114V158.41ZM156.358 150.903H161.72L156.358 156.265V150.903ZM51.618 157.134V151.772L56.9799 157.134H51.618ZM57.8593 156.254L52.4973 150.892H57.8593V156.254ZM59.1032 150.892H64.4652L59.1032 156.254V150.892ZM65.3445 157.123H59.9826L65.3445 151.761V157.123ZM66.5885 157.123V151.761L71.9504 157.123H66.5885ZM72.8191 156.244L67.4571 150.882H72.8191V156.244ZM74.063 150.882H79.425L74.063 156.244V150.882ZM80.3043 157.112H74.9424L80.3043 151.75V157.112ZM81.5483 157.112V151.75L86.9102 157.112H81.5483ZM87.7896 156.233L82.4277 150.871H87.7896V156.233ZM89.0335 150.871H94.3955L89.0335 156.233V150.871ZM95.2641 157.102H89.9022L95.2641 151.74V157.102ZM96.5081 157.102V151.74L101.87 157.102H96.5081ZM102.749 156.222L97.3874 150.86H102.749V156.222ZM103.993 150.86H109.355L103.993 156.222V150.86ZM110.224 157.091H104.862L110.224 151.729V157.091ZM111.468 157.091V151.729L116.83 157.091H111.468ZM117.709 156.211L112.347 150.85H117.709V156.211ZM118.953 150.85H124.315L118.953 156.211V150.85ZM125.194 157.08H119.832L125.194 151.718V157.08ZM126.438 157.08V151.718L131.8 157.08H126.438ZM132.669 156.201L127.307 150.839H132.669V156.201ZM133.913 150.839H139.275L133.913 156.201V150.839ZM140.154 157.069H134.792L140.154 151.707V157.069ZM141.398 150.839H146.76L141.398 156.201V150.839ZM147.639 157.069H142.278L147.639 151.707V157.069ZM148.883 157.069V151.707L154.245 157.069H148.883ZM149.763 150.839H155.125V156.201L149.763 150.839Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M101.946 161.155H78.9321L79.7793 151.504C79.8869 150.242 80.4647 149.066 81.3982 148.21C82.3318 147.354 83.5529 146.88 84.8195 146.882H95.7793C97.021 146.884 98.2188 147.341 99.1458 148.167C100.073 148.993 100.664 150.131 100.809 151.364L101.946 161.155Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M87.0608 150.871H82.6426V155.289H87.0608V150.871Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M92.6477 150.871H88.2295V155.289H92.6477V150.871Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M98.2346 150.871H93.8164V155.289H98.2346V150.871Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M93.8168 128.876C93.8168 129.472 93.6401 130.055 93.309 130.551C92.9779 131.046 92.5072 131.432 91.9566 131.66C91.406 131.889 90.8001 131.948 90.2156 131.832C89.631 131.716 89.0941 131.429 88.6726 131.007C88.2512 130.586 87.9642 130.049 87.8479 129.464C87.7317 128.88 87.7913 128.274 88.0194 127.723C88.2475 127.173 88.6337 126.702 89.1293 126.371C89.6248 126.04 90.2074 125.863 90.8034 125.863C91.6026 125.863 92.3691 126.181 92.9342 126.746C93.4994 127.311 93.8168 128.077 93.8168 128.876Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M163.436 184.49C163.098 184.49 162.763 184.424 162.451 184.294C162.139 184.165 161.855 183.975 161.616 183.736C161.377 183.497 161.188 183.214 161.058 182.901C160.929 182.589 160.862 182.254 160.862 181.916V179.343H166.01V181.916C166.01 182.254 165.943 182.589 165.814 182.901C165.685 183.214 165.495 183.497 165.256 183.736C165.017 183.975 164.733 184.165 164.421 184.294C164.109 184.424 163.774 184.49 163.436 184.49Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M41.5913 218.163L43.5859 339.954H52.4331H103.8H112.637L111.318 218.163H41.5913Z",
					fill: "#F5F5F5"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M45.9453 221.691L46.192 236.512L46.2563 240.576L46.3207 244.651H55.3609L55.2965 240.576L55.2429 236.512L55.007 221.691H45.9453Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M63.2749 221.691L63.5001 236.512L63.5537 240.576L63.6181 244.651H72.6583L72.6047 240.576L72.5511 236.512L72.3473 221.691H63.2749Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M80.605 221.691L80.8087 236.512L80.8624 240.576L80.916 244.651H89.9562L89.9133 240.576L89.8597 236.512L89.6774 221.691H80.605Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M97.9453 221.691L98.1169 236.512L98.192 242.796L98.2134 244.651H107.264L107.243 242.796L107.168 236.512L107.007 221.691H97.9453Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M46.4922 251.364L46.7388 266.174L46.8032 270.238L46.8675 274.303H55.9185L55.8648 270.238L55.8005 266.174L55.5753 251.364H46.4922Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M63.7793 251.364L63.9938 266.174L64.0796 271.9L64.1117 274.303H73.1734L73.1412 271.9L73.0662 266.174L72.8517 251.364H63.7793Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M81.0552 251.364L81.2589 266.174L81.3126 270.238L81.3662 274.303H90.4278L90.3742 270.238L90.3206 266.174L90.1383 251.364H81.0552Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M98.3423 251.364L98.5246 266.174L98.5675 270.238L98.6211 274.303H107.672L107.629 270.238L107.586 266.174L107.425 251.364H98.3423Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M47.0068 280.683L47.2428 295.429L47.3178 299.482L47.3822 303.525H56.4224L56.358 299.482L56.2937 295.429L56.0792 280.683H47.0068Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M64.251 280.683L64.4655 295.429L64.5191 299.482L64.5834 303.525H73.6236L73.57 299.482L73.5164 295.429L73.3126 280.683H64.251Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M81.4844 280.683L81.6774 295.429L81.731 299.482L81.7846 303.525H90.8356L90.782 299.482L90.7283 295.429L90.546 280.683H81.4844Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M98.728 280.683L98.8996 295.429L98.964 301.027L98.9961 303.525H108.036L108.015 301.027L107.951 295.429L107.79 280.683H98.728Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M103.747 309.595H99.2749H90.8996H81.9452H73.5698H64.6261H47.2964L47.4251 317.595H64.7441H73.6771H82.0524H90.9961H99.3714H103.843H108.315L108.229 309.595H103.747Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M90.889 323.514H64.83L64.8086 325.477H65.5914L65.8059 339.954H68.4118L68.1973 325.477H87.5432L87.7255 339.954H90.3207L90.1491 325.477H90.8676L90.889 323.514Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M78.1814 339.954H68.5299L68.3154 325.477H77.9884L78.1814 339.954Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M87.5969 339.954H77.9455L77.7524 325.477H87.4146L87.5969 339.954Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M177.077 225.187L177.86 339.954H169.527H121.13H112.798L111.372 225.187H177.077Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M153.87 311.6H157.42H173.345L173.366 315.278L173.388 318.957L173.495 332.276H165.248L165.141 318.581H157.098H153.924H149.291L149.227 311.6H153.87Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M122.449 311.6H125.624H140.744L140.819 318.581H125.173L125.334 332.276H117.087L116.937 318.957L116.873 313.638L116.841 311.6H122.449Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M133.967 324.49H156.39L156.412 326.453H156.659L156.766 339.954H154.342L154.224 326.453H136.187L136.326 339.954H133.903L133.752 326.453H133.988L133.967 324.49Z",
					fill: "#F5F5F5"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M145.238 339.954H154.246L154.128 326.453H145.109L145.238 339.954Z",
					fill: "#EBEBEB"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M136.423 339.954H145.431L145.302 326.453H136.283L136.423 339.954Z",
					fill: "#E0E0E0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M148.047 229.82H173.045L173.195 251.364H148.251L148.047 229.82Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M115.64 229.82H140.637L140.841 251.364H115.897L115.64 229.82Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M148.744 256.908H172.669L172.83 277.498H148.926L148.744 256.908Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M116.39 256.908H140.315L140.53 277.498H116.626L116.39 256.908Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M148.991 284.908H173.055L173.205 305.552H149.173L148.991 284.908Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M116.733 284.908H140.798L141.001 305.552H116.969L116.733 284.908Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M268.894 399.997C383.728 399.997 476.819 394.562 476.819 387.858C476.819 381.153 383.728 375.718 268.894 375.718C154.06 375.718 60.9692 381.153 60.9692 387.858C60.9692 394.562 154.06 399.997 268.894 399.997Z",
					fill: "#F5F5F5"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M173.27 32.8228L177.27 37.9917H360.497L364.53 32.8228H173.27Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .4,
					children: /* @__PURE__ */ _jsx("path", {
						opacity: .4,
						d: "M173.27 32.8228L177.27 37.9917H360.497L364.53 32.8228H173.27Z",
						fill: "black"
					})
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M360.54 26.1633H176.894V351.718H360.54V26.1633Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .4,
					children: /* @__PURE__ */ _jsx("path", {
						opacity: .4,
						d: "M360.54 26.1633H176.894V351.718H360.54V26.1633Z",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsxs("g", {
					opacity: .8,
					children: [
						/* @__PURE__ */ _jsx("path", {
							opacity: .8,
							d: "M184.336 34.1741C184.407 34.6471 184.375 35.1297 184.243 35.5893C184.111 36.049 183.881 36.4748 183.57 36.8379C183.259 37.201 182.873 37.4929 182.439 37.6939C182.005 37.8948 181.533 38.0001 181.055 38.0025C180.026 37.962 179.047 37.5531 178.294 36.8502C177.542 36.1474 177.068 35.1975 176.958 34.1741C176.884 33.6981 176.914 33.2116 177.045 32.7481C177.176 32.2846 177.406 31.8548 177.718 31.4883C178.031 31.1217 178.419 30.827 178.856 30.6242C179.293 30.4215 179.769 30.3155 180.251 30.3135C181.282 30.3574 182.263 30.7721 183.014 31.4813C183.764 32.1904 184.234 33.1466 184.336 34.1741Z",
							fill: "#F0F0F0"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .8,
							d: "M191.103 34.1741C191.169 34.6498 191.132 35.134 190.995 35.5943C190.858 36.0547 190.625 36.4804 190.31 36.843C189.995 37.2056 189.606 37.4966 189.17 37.6966C188.733 37.8966 188.259 38.0009 187.778 38.0025C186.757 37.952 185.788 37.5386 185.045 36.8367C184.302 36.1348 183.833 35.1905 183.725 34.1741C183.654 33.6968 183.687 33.21 183.821 32.7465C183.955 32.283 184.186 31.8537 184.501 31.4876C184.815 31.1215 185.204 30.8272 185.642 30.6246C186.08 30.4221 186.556 30.316 187.038 30.3135C188.066 30.3625 189.042 30.7793 189.788 31.488C190.535 32.1967 191.001 33.1501 191.103 34.1741Z",
							fill: "#F0F0F0"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .8,
							d: "M197.859 34.1741C197.922 34.6509 197.882 35.1357 197.742 35.596C197.603 36.0563 197.367 36.4816 197.051 36.8438C196.734 37.2059 196.344 37.4965 195.907 37.6963C195.469 37.8961 194.994 38.0005 194.513 38.0025C193.49 37.9647 192.516 37.555 191.774 36.8501C191.032 36.1453 190.572 35.1937 190.481 34.1741C190.416 33.695 190.453 33.2075 190.591 32.744C190.728 32.2806 190.964 31.8518 191.28 31.4865C191.597 31.1211 191.988 30.8274 192.427 30.6252C192.866 30.4229 193.343 30.3166 193.827 30.3135C194.855 30.3521 195.833 30.7664 196.576 31.4779C197.319 32.1894 197.776 33.1486 197.859 34.1741Z",
							fill: "#F0F0F0"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .8,
							d: "M204.615 34.1741C204.671 34.6524 204.625 35.1371 204.481 35.5967C204.337 36.0562 204.098 36.4803 203.78 36.8414C203.461 37.2025 203.07 37.4925 202.632 37.6926C202.194 37.8926 201.719 37.9982 201.237 38.0025C200.217 37.9639 199.247 37.553 198.51 36.8476C197.773 36.1421 197.32 35.191 197.237 34.1741C197.178 33.6927 197.221 33.2042 197.364 32.7408C197.507 32.2773 197.747 31.8493 198.067 31.4848C198.387 31.1203 198.78 30.8276 199.221 30.6257C199.662 30.4238 200.141 30.3174 200.626 30.3135C201.649 30.3531 202.622 30.7689 203.358 31.4812C204.094 32.1936 204.542 33.1524 204.615 34.1741Z",
							fill: "#F0F0F0"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .8,
							d: "M211.382 34.1741C211.433 34.6541 211.383 35.1395 211.235 35.5991C211.087 36.0587 210.845 36.4823 210.524 36.8428C210.203 37.2032 209.81 37.4926 209.37 37.6923C208.931 37.8921 208.454 37.9977 207.972 38.0025C206.955 37.9655 205.987 37.5542 205.255 36.8477C204.523 36.1411 204.077 35.189 204.004 34.1741C203.948 33.6915 203.995 33.2026 204.14 32.7392C204.286 32.2757 204.527 31.8481 204.849 31.484C205.17 31.1199 205.565 30.8276 206.007 30.6259C206.449 30.4242 206.928 30.3178 207.414 30.3135C208.437 30.3488 209.41 30.7638 210.143 31.4775C210.877 32.1913 211.318 33.1526 211.382 34.1741Z",
							fill: "#F0F0F0"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .8,
							d: "M218.138 34.1741C218.184 34.6558 218.129 35.1419 217.978 35.6015C217.826 36.0612 217.581 36.4843 217.257 36.8442C216.934 37.2041 216.539 37.4928 216.098 37.6922C215.657 37.8916 215.179 37.9973 214.695 38.0025C213.681 37.9672 212.716 37.5556 211.989 36.8479C211.261 36.1402 210.823 35.187 210.76 34.1741C210.709 33.6898 210.76 33.2002 210.909 32.7367C211.059 32.2732 211.303 31.8461 211.627 31.4826C211.951 31.1192 212.348 30.8274 212.791 30.6261C213.235 30.4248 213.715 30.3183 214.202 30.3135C215.223 30.347 216.193 30.7623 216.922 31.4772C217.651 32.1921 218.085 33.1545 218.138 34.1741Z",
							fill: "#F0F0F0"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .8,
							d: "M224.926 34.1741C224.967 34.6575 224.909 35.1443 224.753 35.604C224.598 36.0637 224.349 36.4864 224.023 36.8457C223.697 37.205 223.301 37.4932 222.858 37.6922C222.416 37.8912 221.937 37.9969 221.452 38.0025C220.44 37.969 219.477 37.5571 218.754 36.8482C218.032 36.1393 217.601 35.185 217.548 34.1741C217.5 33.6886 217.554 33.1986 217.706 32.7351C217.858 32.2716 218.105 31.8447 218.431 31.4817C218.756 31.1186 219.154 30.8273 219.598 30.6262C220.043 30.4251 220.524 30.3186 221.012 30.3135C222.03 30.3474 222.998 30.7634 223.723 31.4788C224.449 32.1942 224.878 33.1564 224.926 34.1741Z",
							fill: "#F0F0F0"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .8,
							d: "M231.661 34.1741C231.697 34.6601 231.634 35.1484 231.474 35.6089C231.315 36.0694 231.062 36.4922 230.732 36.8511C230.403 37.21 230.003 37.4974 229.557 37.6954C229.112 37.8935 228.631 37.998 228.143 38.0025C227.134 37.9709 226.174 37.5587 225.456 36.8486C224.738 36.1385 224.315 35.183 224.272 34.1741C224.231 33.6873 224.29 33.1972 224.446 32.7343C224.603 32.2715 224.853 31.8457 225.181 31.4836C225.508 31.1215 225.907 30.8307 226.353 30.6294C226.798 30.4281 227.279 30.3206 227.768 30.3135C228.786 30.3427 229.754 30.7579 230.477 31.4748C231.2 32.1917 231.623 33.1567 231.661 34.1741Z",
							fill: "#F0F0F0"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .8,
							d: "M238.417 34.1741C238.449 34.6599 238.382 35.1472 238.22 35.6064C238.058 36.0655 237.804 36.4869 237.474 36.845C237.144 37.2031 236.745 37.4903 236.3 37.6893C235.856 37.8883 235.376 37.9948 234.889 38.0025C233.881 37.9731 232.922 37.561 232.206 36.8498C231.491 36.1387 231.074 35.182 231.039 34.1741C231.002 33.6847 231.066 33.1931 231.227 32.7294C231.388 32.2657 231.641 31.8399 231.973 31.4782C232.305 31.1164 232.707 30.8265 233.155 30.6262C233.603 30.4258 234.087 30.3194 234.578 30.3135C235.59 30.3434 236.553 30.7604 237.267 31.4786C237.981 32.1968 238.393 33.1615 238.417 34.1741Z",
							fill: "#F0F0F0"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .8,
							d: "M245.184 34.1741C245.21 34.6621 245.137 35.1504 244.97 35.6097C244.803 36.069 244.545 36.4899 244.212 36.8473C243.878 37.2047 243.476 37.4912 243.03 37.6896C242.583 37.8881 242.101 37.9945 241.613 38.0025C240.606 37.9779 239.647 37.5663 238.936 36.8533C238.225 36.1403 237.817 35.1807 237.795 34.1741C237.763 33.684 237.831 33.1925 237.994 32.7294C238.158 32.2664 238.414 31.8414 238.747 31.4804C239.08 31.1193 239.483 30.8297 239.931 30.6291C240.38 30.4285 240.864 30.3211 241.355 30.3135C242.368 30.3383 243.332 30.754 244.046 31.4735C244.76 32.1931 245.167 33.1608 245.184 34.1741Z",
							fill: "#F0F0F0"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .8,
							d: "M251.939 34.1741C251.961 34.6628 251.884 35.1509 251.715 35.6097C251.545 36.0684 251.285 36.4885 250.95 36.8453C250.615 37.202 250.212 37.4882 249.765 37.6869C249.318 37.8856 248.836 37.9929 248.347 38.0025C247.344 37.975 246.391 37.5615 245.686 36.8482C244.98 36.135 244.578 35.177 244.561 34.1741C244.534 33.6823 244.606 33.1902 244.773 32.727C244.941 32.2638 245.2 31.8392 245.535 31.4787C245.871 31.1182 246.276 30.8291 246.726 30.6289C247.176 30.4287 247.661 30.3214 248.154 30.3135C249.163 30.3386 250.123 30.7557 250.829 31.4764C251.536 32.1971 251.934 33.1647 251.939 34.1741Z",
							fill: "#F0F0F0"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .8,
							d: "M258.695 34.1741C258.713 34.6644 258.632 35.1532 258.459 35.6121C258.285 36.071 258.022 36.4908 257.685 36.8471C257.347 37.2034 256.943 37.489 256.494 37.6874C256.045 37.8857 255.561 37.9928 255.071 38.0025C254.071 37.9747 253.121 37.5602 252.421 36.8461C251.721 36.132 251.325 35.1741 251.317 34.1741C251.296 33.6811 251.373 33.1888 251.545 32.7262C251.716 32.2635 251.979 31.8399 252.316 31.4801C252.654 31.1204 253.061 30.8319 253.511 30.6315C253.962 30.4311 254.449 30.323 254.942 30.3135C255.949 30.336 256.907 30.7533 257.609 31.4755C258.311 32.1977 258.701 33.1668 258.695 34.1741Z",
							fill: "#F0F0F0"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .8,
							d: "M265.462 34.1741C265.475 34.666 265.391 35.1555 265.213 35.6146C265.036 36.0737 264.77 36.4932 264.43 36.849C264.09 37.2048 263.684 37.4899 263.233 37.6879C262.783 37.8858 262.297 37.9928 261.805 38.0025C260.807 37.98 259.857 37.5661 259.161 36.8499C258.465 36.1338 258.078 35.1728 258.084 34.1741C258.067 33.6795 258.148 33.1865 258.324 32.7237C258.499 32.2609 258.764 31.8375 259.105 31.4783C259.445 31.119 259.853 30.831 260.306 30.6311C260.758 30.4311 261.246 30.3231 261.741 30.3135C262.744 30.3388 263.697 30.758 264.394 31.4805C265.09 32.203 265.474 33.1707 265.462 34.1741Z",
							fill: "#F0F0F0"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .8,
							d: "M272.218 34.1741C272.185 34.8954 271.94 35.5911 271.515 36.1747C271.09 36.7584 270.502 37.2044 269.826 37.4575C269.15 37.7106 268.414 37.7596 267.71 37.5985C267.006 37.4374 266.365 37.0732 265.866 36.5511C265.367 36.029 265.033 35.3719 264.904 34.6614C264.775 33.9509 264.857 33.2181 265.141 32.554C265.424 31.8898 265.896 31.3235 266.499 30.9252C267.101 30.527 267.807 30.3143 268.529 30.3135C269.025 30.3232 269.515 30.431 269.969 30.6305C270.424 30.8301 270.834 31.1176 271.177 31.4764C271.52 31.8352 271.788 32.2583 271.967 32.7212C272.146 33.1842 272.231 33.678 272.218 34.1741Z",
							fill: "#F0F0F0"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .8,
							d: "M278.975 34.1741C278.983 35.1718 278.599 36.1328 277.904 36.8492C277.21 37.5657 276.262 37.98 275.264 38.0025C274.772 37.9928 274.287 37.8858 273.836 37.6879C273.386 37.4899 272.979 37.2048 272.639 36.849C272.299 36.4932 272.033 36.0737 271.856 35.6146C271.679 35.1555 271.594 34.666 271.607 34.1741C271.59 33.1708 271.971 32.2016 272.666 31.4782C273.361 30.7547 274.315 30.336 275.318 30.3135C275.812 30.3231 276.3 30.4311 276.753 30.6311C277.206 30.831 277.614 31.119 277.954 31.4783C278.295 31.8375 278.56 32.2609 278.735 32.7237C278.91 33.1865 278.992 33.6795 278.975 34.1741Z",
							fill: "#F0F0F0"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .8,
							d: "M285.741 34.1741C285.739 35.1757 285.345 36.1367 284.643 36.852C283.942 37.5672 282.989 37.9801 281.988 38.0025C281.497 37.9928 281.014 37.8857 280.565 37.6874C280.116 37.489 279.711 37.2034 279.374 36.8471C279.037 36.4908 278.774 36.071 278.6 35.6121C278.427 35.1532 278.346 34.6644 278.363 34.1741C278.357 33.1687 278.746 32.2011 279.446 31.4792C280.146 30.7573 281.101 30.3387 282.106 30.3135C282.6 30.3231 283.086 30.4311 283.538 30.6314C283.989 30.8316 284.396 31.1199 284.735 31.4795C285.074 31.8391 285.337 32.2626 285.51 32.7253C285.683 33.188 285.761 33.6806 285.741 34.1741Z",
							fill: "#F0F0F0"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .8,
							d: "M292.487 34.1741C292.473 35.176 292.073 36.134 291.369 36.8475C290.666 37.561 289.713 37.9749 288.712 38.0025C288.222 37.9929 287.739 37.8857 287.292 37.6871C286.844 37.4884 286.441 37.2025 286.105 36.8459C285.77 36.4893 285.509 36.0693 285.337 35.6105C285.166 35.1517 285.088 34.6633 285.109 34.1741C285.114 33.1647 285.512 32.1971 286.219 31.4764C286.925 30.7557 287.885 30.3386 288.894 30.3135C289.386 30.3229 289.871 30.4311 290.32 30.6319C290.77 30.8326 291.174 31.1217 291.509 31.4819C291.844 31.8421 292.104 32.2661 292.271 32.7286C292.439 33.1911 292.513 33.6827 292.487 34.1741Z",
							fill: "#F0F0F0"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .8,
							d: "M299.264 34.1741C299.24 35.1799 298.83 36.138 298.12 36.8504C297.409 37.5629 296.452 37.9753 295.446 38.0025C294.958 37.9946 294.477 37.8881 294.031 37.6895C293.585 37.4909 293.183 37.2042 292.851 36.8467C292.518 36.4892 292.261 36.0681 292.096 35.6088C291.93 35.1496 291.859 34.6616 291.886 34.1741C291.9 33.1636 292.303 32.1974 293.013 31.4779C293.723 30.7583 294.683 30.3411 295.693 30.3135C296.185 30.3212 296.669 30.4286 297.118 30.6291C297.567 30.8295 297.971 31.119 298.304 31.4798C298.638 31.8407 298.895 32.2655 299.06 32.7286C299.225 33.1917 299.295 33.6834 299.264 34.1741Z",
							fill: "#F0F0F0"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .8,
							d: "M306.02 34.1741C305.984 35.1874 305.562 36.1487 304.84 36.8606C304.119 37.5726 303.151 37.9812 302.138 38.0025C301.65 37.9947 301.17 37.8882 300.725 37.6894C300.28 37.4905 299.88 37.2035 299.549 36.8456C299.218 36.4877 298.963 36.0664 298.8 35.6072C298.637 35.148 298.568 34.6605 298.599 34.1741C298.623 33.1615 299.035 32.1968 299.749 31.4786C300.463 30.7604 301.426 30.3434 302.438 30.3135C302.932 30.3136 303.421 30.4157 303.874 30.6134C304.327 30.8111 304.735 31.1002 305.071 31.4626C305.407 31.8249 305.665 32.2528 305.828 32.7193C305.991 33.1859 306.057 33.6811 306.02 34.1741Z",
							fill: "#F0F0F0"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .8,
							d: "M312.776 34.1741C312.736 35.1821 312.315 36.1375 311.599 36.8478C310.882 37.5582 309.924 37.9707 308.915 38.0025C308.425 38.0023 307.94 37.901 307.49 37.705C307.04 37.5091 306.636 37.2225 306.302 36.8633C305.968 36.5041 305.711 36.08 305.548 35.6173C305.385 35.1546 305.32 34.6633 305.355 34.1741C305.39 33.1594 305.809 32.196 306.528 31.4791C307.247 30.7623 308.212 30.3455 309.226 30.3135C309.719 30.3132 310.207 30.4153 310.659 30.6134C311.11 30.8114 311.515 31.1011 311.849 31.464C312.183 31.827 312.437 32.2553 312.597 32.7218C312.757 33.1883 312.817 33.6828 312.776 34.1741Z",
							fill: "#F0F0F0"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .8,
							d: "M319.543 34.1741C319.49 35.185 319.059 36.1393 318.336 36.8482C317.613 37.5571 316.651 37.969 315.639 38.0025C315.154 37.9969 314.675 37.8912 314.233 37.6922C313.79 37.4932 313.393 37.205 313.067 36.8457C312.741 36.4864 312.493 36.0637 312.338 35.604C312.182 35.1443 312.123 34.6575 312.165 34.1741C312.208 33.1566 312.634 32.193 313.358 31.4768C314.082 30.7607 315.05 30.3451 316.068 30.3135C316.556 30.3203 317.037 30.4279 317.481 30.6294C317.925 30.831 318.323 31.1221 318.649 31.4846C318.975 31.8471 319.223 32.2732 319.377 32.736C319.531 33.1988 319.587 33.6884 319.543 34.1741Z",
							fill: "#F0F0F0"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .8,
							d: "M326.299 34.1741C326.238 35.1861 325.802 36.1391 325.076 36.8471C324.351 37.555 323.387 37.967 322.374 38.0025C321.889 37.9971 321.411 37.8915 320.97 37.6922C320.528 37.4929 320.133 37.2044 319.809 36.8447C319.484 36.485 319.238 36.062 319.085 35.6024C318.932 35.1427 318.876 34.6564 318.921 34.1741C318.974 33.1545 319.408 32.1921 320.137 31.4772C320.865 30.7623 321.836 30.347 322.856 30.3135C323.343 30.3183 323.824 30.4248 324.267 30.6261C324.711 30.8274 325.107 31.1192 325.431 31.4826C325.755 31.8461 326 32.2732 326.149 32.7367C326.299 33.2002 326.349 33.6898 326.299 34.1741Z",
							fill: "#F0F0F0"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .8,
							d: "M333.055 34.1741C332.987 35.1889 332.544 36.1423 331.813 36.8495C331.082 37.5568 330.114 37.9676 329.098 38.0025C328.619 37.9902 328.148 37.8792 327.715 37.6764C327.281 37.4735 326.894 37.1833 326.578 36.8238C326.262 36.4643 326.023 36.0434 325.878 35.5874C325.732 35.1315 325.682 34.6503 325.731 34.1741C325.794 33.1526 326.235 32.1913 326.969 31.4775C327.703 30.7638 328.676 30.3488 329.698 30.3135C330.18 30.3252 330.653 30.4371 331.089 30.642C331.524 30.8469 331.912 31.1403 332.228 31.5036C332.544 31.8668 332.781 32.2919 332.923 32.7517C333.065 33.2115 333.11 33.6959 333.055 34.1741Z",
							fill: "#F0F0F0"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .8,
							d: "M339.821 34.1741C339.741 35.19 339.29 36.141 338.555 36.8467C337.819 37.5524 336.851 37.9637 335.832 38.0025C335.35 37.9997 334.873 37.8952 334.434 37.6958C333.995 37.4964 333.602 37.2067 333.282 36.8454C332.963 36.4841 332.723 36.0595 332.578 35.5992C332.434 35.1389 332.388 34.6533 332.443 34.1741C332.514 33.1515 332.961 32.1914 333.698 31.4786C334.434 30.7658 335.408 30.3508 336.433 30.3135C336.918 30.3174 337.396 30.4238 337.837 30.6257C338.278 30.8276 338.672 31.1203 338.992 31.4848C339.312 31.8493 339.551 32.2773 339.694 32.7408C339.837 33.2042 339.88 33.6927 339.821 34.1741Z",
							fill: "#F0F0F0"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .8,
							d: "M346.578 34.1741C346.487 35.192 346.029 36.1421 345.289 36.8467C344.549 37.5513 343.577 37.9622 342.556 38.0025C342.075 37.9986 341.601 37.893 341.164 37.6928C340.727 37.4925 340.337 37.2021 340.02 36.8406C339.703 36.4791 339.466 36.0546 339.325 35.595C339.183 35.1355 339.141 34.6512 339.2 34.1741C339.283 33.1504 339.737 32.1926 340.478 31.4813C341.219 30.7701 342.195 30.3547 343.221 30.3135C343.705 30.3168 344.182 30.4231 344.622 30.6253C345.062 30.8275 345.453 31.1209 345.771 31.4861C346.088 31.8512 346.324 32.2798 346.463 32.7432C346.603 33.2067 346.641 33.6944 346.578 34.1741Z",
							fill: "#F0F0F0"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .8,
							d: "M353.344 34.1741C353.237 35.1853 352.773 36.1255 352.037 36.8267C351.3 37.5279 350.338 37.9446 349.323 38.0025C348.843 38.0009 348.368 37.8966 347.932 37.6966C347.495 37.4966 347.106 37.2056 346.792 36.843C346.477 36.4804 346.243 36.0547 346.106 35.5943C345.97 35.134 345.933 34.6498 345.999 34.1741C346.1 33.1518 346.565 32.1999 347.309 31.4914C348.053 30.7829 349.026 30.365 350.052 30.3135C350.532 30.3207 351.005 30.4303 351.44 30.6347C351.874 30.8392 352.26 31.1339 352.571 31.4992C352.883 31.8645 353.113 32.292 353.246 32.7533C353.38 33.2145 353.413 33.6989 353.344 34.1741Z",
							fill: "#F0F0F0"
						}),
						/* @__PURE__ */ _jsx("path", {
							opacity: .8,
							d: "M360.1 34.1741C359.991 35.1958 359.518 36.1442 358.768 36.8468C358.019 37.5494 357.041 37.9595 356.015 38.0025C355.536 37.9998 355.064 37.8945 354.629 37.6937C354.195 37.4928 353.809 37.2011 353.496 36.8382C353.184 36.4754 352.954 36.0498 352.82 35.5902C352.687 35.1306 352.653 34.6477 352.722 34.1741C352.825 33.1466 353.294 32.1904 354.045 31.4813C354.795 30.7721 355.777 30.3574 356.808 30.3135C357.29 30.3155 357.766 30.4215 358.203 30.6242C358.64 30.827 359.028 31.1217 359.34 31.4883C359.653 31.8548 359.883 32.2846 360.014 32.7481C360.145 33.2116 360.175 33.6981 360.1 34.1741Z",
							fill: "#F0F0F0"
						})
					]
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M173.259 27.5896H364.54L364.53 32.8229H173.27L173.259 27.5896Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M173.248 22.3562L177.237 27.5894H360.519L364.551 22.3562H173.248Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .4,
					children: /* @__PURE__ */ _jsx("path", {
						opacity: .4,
						d: "M173.248 22.3562L177.237 27.5894H360.519L364.551 22.3562H173.248Z",
						fill: "black"
					})
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M173.227 17.1016H364.562L364.551 22.3563H173.248L173.227 17.1016Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .8,
					children: /* @__PURE__ */ _jsx("path", {
						opacity: .8,
						d: "M177.227 22.3562H360.53L360.519 27.5894H177.237L177.227 22.3562Z",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .7,
					children: /* @__PURE__ */ _jsx("path", {
						opacity: .7,
						d: "M360.583 130.614H176.948V132.919H360.583V130.614Z",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .8,
					children: /* @__PURE__ */ _jsx("path", {
						opacity: .8,
						d: "M360.573 245.048H177.323V247.343H360.573V245.048Z",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M237.709 48.0186H215.007V72.544H237.709V48.0186Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M281.312 48.0186H258.61V72.544H281.312V48.0186Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M324.916 48.0186H302.213V72.544H324.916V48.0186Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M237.709 84.7371H215.007V109.263H237.709V84.7371Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M281.312 84.7371H258.61V109.263H281.312V84.7371Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M324.916 84.7371H302.213V109.263H324.916V84.7371Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M237.709 262.71H215.007V287.236H237.709V262.71Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M281.312 262.71H258.61V287.236H281.312V262.71Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M324.916 262.71H302.213V287.236H324.916V262.71Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M213.387 314.345H190.685V338.871H213.387V314.345Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M346.771 314.345H324.068V338.871H346.771V314.345Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M237.709 152.244H215.007V176.769H237.709V152.244Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M281.312 152.244H258.61V176.769H281.312V152.244Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M324.916 152.244H302.213V176.769H324.916V152.244Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M237.709 188.962H215.007V213.488H237.709V188.962Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M281.312 188.962H258.61V213.488H281.312V188.962Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M324.916 188.962H302.213V213.488H324.916V188.962Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .8,
					children: /* @__PURE__ */ _jsx("path", {
						opacity: .8,
						d: "M242.46 317.219H265.956L265.859 341.616H242.299L242.46 317.219Z",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .8,
					children: /* @__PURE__ */ _jsx("path", {
						opacity: .8,
						d: "M270.492 317.219H294.953L293.795 341.616H270.234L270.492 317.219Z",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M298.696 346.528H236.701L236.455 341.616H298.932L298.696 346.528Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .1,
					children: /* @__PURE__ */ _jsx("path", {
						opacity: .1,
						d: "M298.696 346.528H236.701L236.455 341.616H298.932L298.696 346.528Z",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M301.194 351.718H234.513L234.245 346.882H301.441L301.194 351.718Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .4,
					children: /* @__PURE__ */ _jsx("path", {
						opacity: .4,
						d: "M303.404 308.576H232.133L231.822 303.053H303.682L303.404 308.576Z",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M232.133 308.576L242.46 317.22H294.953L303.404 308.576H232.133Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M236.958 312.619L240.605 341.573H243.5L242.331 312.619C241.502 312.193 240.583 311.97 239.65 311.97C238.718 311.97 237.799 312.193 236.969 312.619H236.958Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M299.586 312.619L296.015 341.573H293.119L294.192 312.619C294.988 312.097 295.92 311.819 296.872 311.819C297.825 311.819 298.757 312.097 299.553 312.619H299.586Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M177.227 22.3562H360.53L360.519 27.5894H177.237L177.227 22.3562Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M165.341 189.938C171.077 197.702 173.298 201.273 175.52 203.471C177.944 205.874 202.701 204.04 205.692 202.785C207.977 201.82 206.397 198.839 205.318 198.989C201.238 199.557 185.922 196.844 181.383 194.871C180.593 194.517 172.839 185.048 172.839 185.048L165.341 189.938Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M174.761 184.801C169.912 175.868 160.353 169.316 157.459 168.941C153.294 168.394 151.895 169.23 153.112 172.587C155.184 178.303 158.997 184.308 164.369 191.579L174.761 184.801Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .1,
					children: /* @__PURE__ */ _jsx("path", {
						opacity: .1,
						d: "M174.761 184.801C169.912 175.868 160.353 169.316 157.459 168.941C153.294 168.394 151.895 169.23 153.112 172.587C155.184 178.303 158.997 184.308 164.369 191.579L174.761 184.801Z",
						fill: "black"
					})
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M157.459 168.941C155.118 168.086 152.728 167.37 150.303 166.796C145.874 165.726 141.373 164.981 136.835 164.565C134.196 164.28 131.544 164.133 128.889 164.126C128.62 164.122 128.351 164.151 128.088 164.212C127.089 164.461 126.225 165.09 125.677 165.966C125.13 166.842 124.941 167.896 125.151 168.909C129.605 192.555 129.818 203.043 129.178 215.225L156.284 216.19C156.629 216.192 156.963 216.069 157.226 215.845C157.488 215.621 157.662 215.309 157.716 214.968C158.922 208.834 162.671 195.203 162.671 195.203C166.057 191.933 166.623 187.901 166.943 185.552C167.136 184.276 164.295 182.892 161.208 176.136C161.261 176.136 158.848 169.423 157.459 168.941Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M140.328 215.6L150.207 215.965C151.681 204.169 151.403 193.756 150.891 182.024C147.953 193.393 144.427 204.6 140.328 215.6Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M137.466 306.324C137.712 305.777 137.957 305.252 138.192 304.63C148.851 279.053 156.99 227.332 156.99 227.332L137.989 217.681C137.989 217.681 132.585 263.128 125.173 292.694C124.041 297.198 122.877 301.273 121.67 304.844L134.646 310.828L137.466 306.324Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .8,
					children: /* @__PURE__ */ _jsx("path", {
						opacity: .8,
						d: "M137.466 306.324C137.712 305.777 137.957 305.252 138.192 304.63C148.851 279.053 156.99 227.332 156.99 227.332L137.989 217.681C137.989 217.681 132.585 263.128 125.173 292.694C124.041 297.198 122.877 301.273 121.67 304.844L134.646 310.828L137.466 306.324Z",
						fill: "#263238"
					})
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M155.591 220.662C155.591 220.662 164.284 281.788 162.234 306.785C160.098 333.134 152.301 378.249 152.301 378.249L145.893 377.809C143.717 354.277 144.251 330.57 147.484 307.161C132.799 269.209 131.154 221.627 131.154 221.627L155.591 220.662Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .8,
					d: "M155.591 220.662C155.591 220.662 164.284 281.788 162.234 306.785C160.098 333.134 152.301 378.249 152.301 378.249L145.893 377.809C143.717 354.277 144.251 330.57 147.484 307.161C132.799 269.209 131.154 221.627 131.154 221.627L155.591 220.662Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M145.059 379.826C144.613 380.681 144.368 381.627 144.343 382.592C144.172 386.121 143.926 395.525 143.926 395.525L144.695 395.579C144.695 395.579 145.165 390.968 145.699 388.662C146.233 386.356 146.586 388.34 147.761 390.86C148.935 393.381 152.236 395.965 157.256 396.437C163.14 396.984 165.543 396.877 163.931 395.214C162.318 393.552 158.462 392.308 158.462 392.308C158.462 392.308 153.336 383.504 153.635 377.563C153.955 371.225 146.661 377.177 145.251 376.287C144.749 376.394 145.347 379.311 145.059 379.826Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M124.745 294.893C128.472 295.697 131.783 298.453 141.577 299.439H142.165C142.581 299.439 143.008 299.515 143.457 299.536C146.084 299.675 161.133 298.968 163.92 297.327C161.496 272.179 156.722 218.742 156.722 218.742L145.24 217.37L130.427 216.919C130.427 216.919 114.086 233.863 117.845 249.241C123.453 272.244 120.676 275.815 124.745 294.893Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M129.317 203.139C129.709 202.743 130.009 202.264 130.194 201.737C130.379 201.211 130.444 200.649 130.385 200.093C130.385 200.093 130.385 198.399 130.438 195.804C130.524 188.297 130.588 173.284 129.808 171.289C128.099 167 125.173 164.651 123.646 167.16C121.851 170.099 121.723 192.394 121.723 192.394C122.182 207.15 127.565 205.198 129.317 203.139Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M132.872 163.686L133.77 165.305C137.23 171.568 145.24 179.729 148.37 180.523C149.1 178.823 150.224 177.323 151.649 176.147C152.481 176.56 153.221 177.139 153.824 177.849C154.426 178.559 154.878 179.385 155.152 180.276C157.832 175.901 157.598 170.367 156.925 167.632C155.344 167.15 153.656 166.657 152.054 166.26C147.621 165.229 143.12 164.512 138.586 164.115C136.693 163.852 134.784 163.708 132.872 163.686Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .8,
					d: "M132.873 163.686L133.77 165.305C137.23 171.568 145.241 179.729 148.37 180.522C148.96 179.003 149.455 177.449 149.854 175.868C151.531 176.705 152.77 179.085 153.326 180.887C156.017 176.512 157.598 170.367 156.925 167.632C155.344 167.15 153.657 166.657 152.055 166.26C147.621 165.229 143.12 164.512 138.587 164.115C136.693 163.852 134.784 163.708 132.873 163.686Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M153.486 194.367L157.203 189.305L160.524 195.911C160.524 195.911 157.128 197.82 154.308 197.177L153.486 194.367Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M163.088 187.75L164.668 193.091L160.524 195.879L157.203 189.305L163.088 187.75Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M129.22 218.335L142.944 218.71H144.097L147.067 218.796H148.199L156.262 219.01C156.508 219.01 156.732 218.882 156.743 218.721L157.063 216.126C157.063 215.954 156.861 215.793 156.583 215.783L148.615 215.461H147.665L143.724 215.311H142.794L129.572 214.785C129.481 214.775 129.39 214.789 129.305 214.824C129.221 214.86 129.148 214.917 129.092 214.989L128.771 217.938C128.643 218.11 128.878 218.324 129.22 218.335Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M129.22 218.335L142.944 218.71H144.097L147.067 218.796H148.199L156.262 219.01C156.508 219.01 156.732 218.882 156.743 218.721L157.063 216.126C157.063 215.954 156.861 215.793 156.583 215.783L148.615 215.461H147.665L143.724 215.311H142.794L129.572 214.785C129.481 214.775 129.39 214.789 129.305 214.824C129.221 214.86 129.148 214.917 129.092 214.989L128.771 217.938C128.643 218.11 128.878 218.324 129.22 218.335Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M152.439 219.3H151.564C151.529 219.308 151.493 219.308 151.458 219.301C151.423 219.293 151.391 219.278 151.362 219.257C151.334 219.235 151.31 219.208 151.293 219.177C151.277 219.145 151.267 219.111 151.264 219.075L151.756 215.397C151.756 215.289 151.927 215.193 152.108 215.193H152.984C153.166 215.193 153.294 215.3 153.283 215.407L152.792 219.096C152.763 219.164 152.712 219.22 152.649 219.257C152.586 219.293 152.512 219.309 152.439 219.3Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M137.146 219.075H136.313C136.281 219.083 136.248 219.084 136.216 219.078C136.184 219.073 136.153 219.06 136.126 219.042C136.099 219.024 136.076 219 136.058 218.973C136.041 218.945 136.029 218.914 136.024 218.882L136.526 215.182C136.526 215.086 136.697 214.989 136.857 215H137.69C137.861 215 137.979 215.086 137.968 215.204L137.477 218.871C137.466 219 137.317 219.075 137.146 219.075Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M132.595 234.957L134.731 234.195L125.226 205.638C123.709 201.102 124.286 196.769 129.893 194.785C135.137 192.93 139.26 195.579 140.787 200.147L150.4 228.619L152.536 227.858L142.923 199.407C141.15 194.142 137.733 190.571 129.487 193.498C121.242 196.426 121.402 201.144 123.165 206.431L132.595 234.957Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M127.223 252.576L168.876 237.563L159.435 209.874C159.225 209.232 158.891 208.639 158.451 208.129C158.01 207.619 157.473 207.202 156.871 206.902C156.268 206.603 155.612 206.427 154.941 206.385C154.27 206.342 153.598 206.435 152.963 206.656L122.609 217.488C120.95 218.104 119.594 219.343 118.827 220.943C118.06 222.543 117.942 224.38 118.497 226.067L127.223 252.576Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .4,
					d: "M131.836 250.925L164.294 239.214C165.52 238.75 166.517 237.823 167.07 236.63C167.623 235.437 167.689 234.074 167.253 232.833L159.424 209.874C159.214 209.232 158.88 208.639 158.439 208.129C157.999 207.619 157.462 207.202 156.86 206.902C156.257 206.603 155.601 206.427 154.93 206.385C154.259 206.342 153.587 206.435 152.952 206.656L122.598 217.488C120.939 218.104 119.583 219.343 118.816 220.943C118.049 222.543 117.93 224.38 118.486 226.067L125.653 247.804C125.846 248.423 126.16 248.996 126.578 249.49C126.997 249.984 127.509 250.389 128.086 250.68C128.663 250.971 129.292 251.142 129.937 251.185C130.581 251.227 131.227 251.138 131.836 250.925Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .3,
					children: /* @__PURE__ */ _jsx("path", {
						opacity: .3,
						d: "M132.596 234.957L134.272 236.426L134.71 234.195L125.205 205.638C123.688 201.102 124.265 196.769 129.872 194.785C135.116 192.93 139.239 195.579 140.766 200.147L150.378 228.619L152.109 230.067L152.482 227.858L142.87 199.407C141.097 194.142 137.679 190.571 129.434 193.498C121.189 196.426 121.349 201.144 123.111 206.431L132.596 234.957Z",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M146.053 217.767L149.524 216.523L149.086 215.204L145.615 216.448L146.053 217.767Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M148.937 226.324L152.418 225.08L151.97 223.761L148.499 225.005L148.937 226.324Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M128.206 224.158L131.688 222.914L131.25 221.584L127.768 222.828L128.206 224.158Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M131.058 232.748L134.55 231.493L134.112 230.163L130.62 231.418L131.058 232.748Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M135.095 222.539L142.55 219.868L141.61 217.037L134.155 219.708L135.095 222.539Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M126.101 204.458C129.444 206.389 142.965 204.212 154.404 197.305C154.938 196.973 155.472 197.016 155.675 196.887C156.391 196.362 154.607 195.15 153.539 194.592C152.952 194.292 127.714 197.498 125.973 197.734C123.997 202.903 125.781 202.839 126.101 204.458Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M136.878 308.394C135.041 313.659 128.878 315.976 124.563 312.683C124.389 312.549 124.221 312.406 124.061 312.255C105.371 294.882 81.5963 269.563 81.5963 269.563L85.6014 264.469C99.6046 272.618 112.833 282.041 125.119 292.619C129.391 296.297 133.823 300.319 138.138 304.608L136.878 308.394Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .8,
					d: "M136.878 308.394C135.041 313.659 128.878 315.976 124.563 312.683C124.389 312.549 124.221 312.406 124.061 312.255C105.371 294.882 81.5963 269.563 81.5963 269.563L85.6014 264.469C99.6046 272.618 112.833 282.041 125.119 292.619C129.391 296.297 133.823 300.319 138.138 304.608L136.878 308.394Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M88.0263 265.112C87.7628 264.251 87.2935 263.466 86.6592 262.828C84.4164 260.48 78.3499 254.431 78.3499 254.431L77.8052 254.978C77.8052 254.978 80.5394 258.195 81.7142 260.04C82.8891 261.884 81.3404 260.898 78.8946 260.201C76.4488 259.504 72.5398 260.351 68.8871 263.804C64.615 267.868 63.0556 269.745 65.2237 269.563C67.3919 269.38 70.7989 267.3 70.7989 267.3C70.7989 267.3 80.0588 269.005 83.8183 272.984C87.8554 277.273 88.7312 267.976 90.2265 267.472C90.5469 267.01 88.1865 265.649 88.0263 265.112Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M152.172 162.903C150.164 165.305 148.605 168.265 151.275 171.75C151.86 172.494 152.17 173.419 152.151 174.367C152.086 175.879 151.082 177.295 146.469 174.056C139.74 169.381 140.658 164.694 140.658 164.694C144.418 163.815 147.152 156.115 148.306 151.75L152.172 162.903Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M148.242 158.474C147.58 160.34 149.364 163.515 150.795 164.823C151.191 164.142 151.648 163.499 152.162 162.903L149.876 156.297C149.191 156.905 148.636 157.646 148.242 158.474Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M168.225 142.431C170.02 149.434 167.35 157.112 162.426 162.388C157.449 156.909 148.039 158.099 142.806 152.866C139.303 149.391 138.662 143.557 140.83 139.118C143.159 134.335 150.037 129.724 155.462 130.474C161.539 131.321 166.719 136.533 168.225 142.431Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M147.495 140.051C148.218 138.983 149.145 138.069 150.22 137.361C151.296 136.653 152.5 136.165 153.764 135.925C155.028 135.685 156.327 135.698 157.586 135.962C158.845 136.227 160.039 136.738 161.101 137.466C167.414 141.756 166.239 152.48 163.419 158.539C160.322 165.316 151.276 165.595 147.057 158.946C144.226 154.517 144.825 151.493 145.871 144.297C146.078 142.775 146.634 141.321 147.495 140.051Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M159.852 155.064C160.186 155.222 160.551 155.304 160.92 155.304C161.289 155.304 161.654 155.222 161.988 155.064C161.367 153.755 160.932 152.365 160.695 150.935L159.852 155.064Z",
					fill: "#ED893E"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M154.373 154.41C154.363 154.389 154.357 154.366 154.357 154.343C154.356 154.32 154.36 154.296 154.37 154.275C154.379 154.254 154.392 154.234 154.41 154.219C154.427 154.203 154.447 154.192 154.469 154.185C154.512 154.17 154.559 154.172 154.6 154.19C154.642 154.207 154.675 154.24 154.694 154.281C155.004 154.947 155.468 155.528 156.048 155.976C156.628 156.423 157.306 156.725 158.026 156.855C158.069 156.87 158.106 156.899 158.129 156.939C158.153 156.978 158.162 157.024 158.154 157.069C158.15 157.091 158.142 157.111 158.13 157.129C158.119 157.147 158.103 157.163 158.085 157.175C158.067 157.187 158.047 157.195 158.026 157.199C158.005 157.203 157.983 157.203 157.962 157.198C157.686 157.145 157.414 157.069 157.15 156.973C156.54 156.754 155.98 156.415 155.503 155.974C155.026 155.534 154.642 155.002 154.373 154.41Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M159.446 134.195C160.012 135.108 160.376 136.132 160.514 137.198C152.172 139.128 146.02 147.922 143.649 156.254C141.396 153.273 136.974 149.627 135.255 146.045C133.343 142.024 135.895 137.466 139.74 135.214C143.144 133.527 146.681 132.125 150.314 131.021C151.971 130.458 153.768 130.464 155.421 131.038C157.074 131.613 158.49 132.724 159.446 134.195Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M142.731 148.63C142.792 148.324 142.913 148.033 143.086 147.774C143.26 147.515 143.482 147.293 143.741 147.121C144 146.949 144.29 146.829 144.595 146.77C144.9 146.71 145.214 146.712 145.519 146.774C147.281 147.161 147.922 149.638 147.815 151.225C147.665 152.973 146.309 154.185 144.814 153.091C143.673 152.261 142.905 151.012 142.678 149.616C142.631 149.287 142.649 148.952 142.731 148.63Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M156.476 147.976C156.284 148.673 156.476 149.348 156.967 149.477C157.459 149.606 157.939 149.134 158.121 148.405C158.302 147.675 158.121 147.032 157.64 146.914C157.16 146.796 156.668 147.214 156.476 147.976Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M162.842 150.217C162.65 150.914 162.842 151.589 163.333 151.707C163.824 151.825 164.305 151.364 164.497 150.635C164.69 149.906 164.497 149.262 164.006 149.134C163.515 149.005 163.023 149.498 162.842 150.217Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M163.793 149.145H165.598C165.598 149.145 164.391 150.196 163.793 149.145Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M155.131 144.758C155.078 144.727 155.034 144.683 155.003 144.63C154.953 144.551 154.935 144.456 154.953 144.364C154.971 144.272 155.023 144.19 155.099 144.136C155.644 143.76 156.272 143.522 156.929 143.444C157.586 143.366 158.251 143.449 158.869 143.686C158.953 143.728 159.017 143.799 159.051 143.887C159.085 143.974 159.085 144.071 159.051 144.158C159.011 144.241 158.942 144.306 158.857 144.339C158.772 144.373 158.677 144.373 158.592 144.34C158.078 144.15 157.527 144.087 156.984 144.156C156.441 144.225 155.923 144.424 155.473 144.737C155.422 144.768 155.364 144.785 155.305 144.789C155.245 144.793 155.186 144.782 155.131 144.758Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M165.865 148.587C165.824 148.541 165.788 148.491 165.758 148.437C165.57 147.922 165.262 147.459 164.861 147.086C164.461 146.713 163.977 146.441 163.451 146.292C163.359 146.276 163.277 146.224 163.223 146.148C163.169 146.072 163.148 145.977 163.163 145.884C163.173 145.838 163.192 145.795 163.219 145.756C163.246 145.718 163.281 145.685 163.321 145.66C163.36 145.635 163.405 145.619 163.451 145.611C163.497 145.603 163.545 145.605 163.59 145.616C164.231 145.787 164.821 146.109 165.314 146.555C165.806 147 166.185 147.557 166.421 148.179C166.44 148.222 166.452 148.267 166.454 148.314C166.456 148.361 166.449 148.407 166.433 148.451C166.417 148.495 166.393 148.535 166.361 148.569C166.33 148.604 166.292 148.632 166.25 148.651C166.187 148.677 166.118 148.686 166.05 148.677C165.983 148.667 165.919 148.64 165.865 148.598V148.587Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M157.426 146.903H159.231C159.231 146.903 158.057 147.901 157.426 146.903Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M166.847 152.544C166.025 156.952 162.468 163.032 158.677 165.413C161.23 167.354 165.801 165.155 168.492 163.429C169.813 162.516 170.926 161.332 171.756 159.954C172.587 158.577 173.116 157.038 173.309 155.44C173.682 152.234 173.249 148.986 172.049 145.992C170.09 141.144 166.842 136.93 162.661 133.809C161.849 133.145 160.461 132.619 159.927 133.52C159.553 134.142 159.98 134.925 160.386 135.515C164.327 141.241 167.424 145.273 166.847 152.544Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M147.025 160.597H147.089C147.157 160.58 147.215 160.536 147.25 160.476C147.286 160.416 147.297 160.344 147.281 160.276C144.43 148.705 156.787 139.9 160.642 137.434C160.701 137.396 160.743 137.337 160.759 137.269C160.775 137.201 160.764 137.129 160.728 137.069C160.71 137.039 160.687 137.013 160.659 136.992C160.631 136.971 160.599 136.956 160.565 136.948C160.531 136.94 160.495 136.939 160.461 136.945C160.427 136.951 160.394 136.964 160.365 136.984C156.424 139.461 143.821 148.48 146.758 160.404C146.775 160.462 146.81 160.512 146.858 160.547C146.907 160.582 146.965 160.6 147.025 160.597Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M144.856 152.211L145.091 156.297L144.002 157.198L143.468 155.943L144.856 152.211Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M126.86 164.49C127.712 164.272 128.606 164.282 129.453 164.519C130.3 164.756 131.07 165.212 131.687 165.841C133.048 167.345 133.907 169.239 134.144 171.257C134.539 174.345 133.759 177.477 132.926 180.49C131.906 183.462 131.337 186.571 131.239 189.713C127.97 187.922 123.218 184.351 118.647 183.879C119.277 176.576 120.12 171.707 121.53 169.295C122.259 167.858 123.24 166.565 124.425 165.477C125.162 164.988 125.99 164.652 126.86 164.49Z",
					fill: "#407BFF"
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .1,
					children: /* @__PURE__ */ _jsx("path", {
						opacity: .1,
						d: "M126.86 164.49C127.712 164.272 128.606 164.282 129.453 164.519C130.3 164.756 131.07 165.212 131.687 165.841C133.048 167.345 133.907 169.239 134.144 171.257C134.539 174.345 133.759 177.477 132.926 180.49C131.906 183.462 131.337 186.571 131.239 189.713C127.97 187.922 123.218 184.351 118.647 183.879C119.277 176.576 120.12 171.707 121.53 169.295C122.259 167.858 123.24 166.565 124.425 165.477C125.162 164.988 125.99 164.652 126.86 164.49Z",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M204.698 198.914C204.698 198.914 212.762 200.255 212.869 200.619C212.976 200.984 212.933 205.541 212.933 205.541L205.692 202.785L204.698 198.914Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M212.933 205.541L219.747 199.096L216.703 198.206L211.651 200.962L212.933 205.541Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M356.822 389.666L349.846 388.358L351.028 371.852L358.004 373.169L356.822 389.666Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M403.768 389.477H396.666L394.906 373.043H401.999L403.768 389.477Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M396.088 388.655H404.733C404.875 388.656 405.011 388.705 405.121 388.793C405.231 388.882 405.307 389.005 405.338 389.143L406.746 395.46C406.778 395.613 406.776 395.772 406.739 395.925C406.701 396.077 406.63 396.22 406.531 396.341C406.431 396.462 406.305 396.56 406.163 396.626C406.021 396.692 405.865 396.725 405.708 396.723C402.92 396.678 400.889 396.507 397.388 396.507C395.231 396.507 388.724 396.732 385.746 396.732C382.768 396.732 382.38 393.79 383.598 393.519C389.067 392.328 393.182 390.677 394.933 389.106C395.248 388.817 395.66 388.656 396.088 388.655Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M349.991 386.823L357.635 388.141C357.773 388.165 357.899 388.235 357.993 388.34C358.086 388.445 358.141 388.578 358.149 388.719L358.456 395.171C358.464 395.327 358.436 395.483 358.376 395.626C358.315 395.77 358.223 395.898 358.106 396.002C357.989 396.105 357.85 396.18 357.7 396.222C357.549 396.265 357.391 396.272 357.238 396.245C354.53 395.722 350.533 394.873 347.076 394.278C343.024 393.583 341.048 393.077 336.301 392.256C333.431 391.76 334.054 388.646 335.308 388.565C340.985 388.312 342.988 389.179 348.213 387.076C348.771 386.828 349.386 386.74 349.991 386.823Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M374.294 172.312C374.05 173.034 373.861 173.557 373.635 174.117C373.409 174.676 373.184 175.272 372.949 175.84C372.48 176.986 371.984 178.106 371.46 179.225C370.415 181.47 369.243 183.655 367.95 185.767C365.304 190.287 361.858 194.286 357.779 197.571C356.644 198.437 355.436 199.204 354.169 199.863C353.844 200.044 353.511 200.197 353.168 200.351C352.825 200.504 352.518 200.649 352.112 200.802C351.312 201.096 350.487 201.32 349.648 201.47C348.285 201.7 346.906 201.817 345.524 201.822C344.224 201.822 342.979 201.822 341.752 201.704C336.964 201.323 332.227 200.464 327.61 199.142L328.323 193.862C332.836 193.691 337.411 193.546 341.707 193.167C342.78 193.068 343.836 192.942 344.838 192.788C345.755 192.664 346.661 192.465 347.545 192.193C347.834 192.11 348.113 191.995 348.376 191.85C348.673 191.669 349.08 191.498 349.413 191.263C350.149 190.799 350.846 190.277 351.498 189.702C352.938 188.425 354.236 186.997 355.37 185.442C356.605 183.793 357.733 182.066 358.745 180.271C359.801 178.466 360.748 176.544 361.678 174.613C362.129 173.647 362.58 172.664 362.977 171.68L363.582 170.209L364.132 168.819L374.294 172.312Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M370.874 163.991C383.824 163.991 369.592 191.967 369.592 191.967L353.068 185.28C353.068 185.28 357.581 175.552 360.55 169.983C361.511 168.097 362.997 166.528 364.828 165.465C366.659 164.402 368.759 163.891 370.874 163.991Z",
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .3,
					children: /* @__PURE__ */ _jsx("path", {
						opacity: .3,
						d: "M370.874 163.991C383.824 163.991 369.592 191.967 369.592 191.967L353.068 185.28C353.068 185.28 357.581 175.552 360.55 169.983C361.511 168.097 362.997 166.528 364.828 165.465C366.659 164.402 368.759 163.891 370.874 163.991Z",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M367.706 173.034C362.968 176.364 359.674 182.545 358.736 187.563L368.175 191.389C369.89 188.827 371.56 185.803 373.401 183.15C373.906 181.769 374.402 180.316 374.835 178.845L367.706 173.034Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M332.384 194.539L326.708 191.335L322.358 199.457C324.87 199.883 327.441 199.818 329.929 199.268L332.384 194.539Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M321.275 191.335L318.116 198.501L322.322 199.485L326.671 191.335H321.275Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M351.029 371.861L350.424 380.362L357.4 381.67L358.005 373.169L351.029 371.861Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M401.999 373.052H394.897L395.817 381.526H402.911L401.999 373.052Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M406.187 167.087C404.106 174.746 402.597 182.55 401.674 190.433C400.998 195.929 400.601 201.172 400.348 205.937C399.752 217.091 400.005 225.592 399.671 228.498C394.121 228.119 373.211 226.693 361.768 225.863C356.615 185.497 366.461 164.704 366.461 164.704C369.443 164.144 372.457 163.767 375.485 163.576C376.126 163.576 376.785 163.513 377.444 163.504C382.827 163.567 388.203 163.941 393.543 164.623C394.554 164.74 395.583 164.894 396.576 165.056C401.729 165.85 406.187 167.087 406.187 167.087Z",
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .3,
					children: /* @__PURE__ */ _jsx("path", {
						opacity: .3,
						d: "M406.187 167.087C404.106 174.746 402.597 182.55 401.674 190.433C400.998 195.929 400.601 201.172 400.348 205.937C399.752 217.091 400.005 225.592 399.671 228.498C394.121 228.119 373.211 226.693 361.768 225.863C356.615 185.497 366.461 164.704 366.461 164.704C369.443 164.144 372.457 163.767 375.485 163.576C376.126 163.576 376.785 163.513 377.444 163.504C382.827 163.567 388.203 163.941 393.543 164.623C394.554 164.74 395.583 164.894 396.576 165.056C401.729 165.85 406.187 167.087 406.187 167.087Z",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M396.63 177.302C396.557 183.111 398.185 188.814 401.313 193.709C401.422 192.626 401.548 191.534 401.683 190.433C402.189 186.3 402.839 182.022 403.696 177.699L396.63 177.302Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M393.29 146.357C391.919 151.474 390.24 160.887 393.624 164.596C391.913 166.148 389.888 167.315 387.686 168.017C385.485 168.72 383.158 168.941 380.864 168.666C376.415 168.26 376.415 165.128 377.525 163.477C383.399 162.502 383.544 158.207 382.822 154.109L393.29 146.357Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M377.605 170.353C377.71 171.15 377.897 171.933 378.165 172.691C378.241 172.932 378.393 173.143 378.597 173.292C378.802 173.441 379.048 173.521 379.302 173.521C380.043 173.51 380.784 173.574 381.513 173.711C381.666 173.746 381.825 173.751 381.981 173.723C382.136 173.695 382.284 173.635 382.415 173.548C383.317 172.98 384.473 172.14 384.175 171.093C383.823 169.866 381.711 168.756 381.711 168.756C381.711 168.756 378.083 169.65 377.605 170.353Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M379.51 172.691C378.057 175.867 374.7 196.208 374.284 199.286C373.869 202.363 375.286 207.327 377.254 211.27C379.515 208.169 380.803 204.466 380.954 200.63C381.215 196.425 381.468 173.196 381.468 173.196L379.51 172.691Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M381.685 168.756C383.028 169.877 384.138 171.25 384.952 172.799C387.235 172.619 397.315 168.197 395.881 164.785C394.626 164.433 393.525 163.711 393.173 164.081C392.695 164.812 388.417 167.393 381.685 168.756Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M381.685 168.756C381.685 168.756 377.813 170.065 376.911 172.267C374.573 171.229 373.301 166.545 375.368 163.468C376.658 163.36 377.894 162.719 378.129 163.143C378.49 163.946 377.506 166.103 381.685 168.756Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M389.022 149.525L382.822 154.1C383.009 155.055 383.108 156.024 383.12 156.997C385.349 156.835 388.534 154.624 388.949 152.332C389.146 151.408 389.17 150.457 389.022 149.525Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M378.255 129.924C375.548 130.989 374.546 141.466 380.06 140.437C385.574 139.409 383.706 127.785 378.255 129.924Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M396.133 140.401C393.922 147.088 392.974 151.113 388.625 153.703C382.073 157.593 374.501 152.268 374.664 145.058C374.808 138.569 378.391 128.714 385.764 127.767C387.387 127.547 389.04 127.746 390.564 128.346C392.089 128.945 393.435 129.924 394.474 131.191C395.513 132.457 396.211 133.968 396.502 135.58C396.792 137.192 396.665 138.852 396.133 140.401Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M393.624 145.004C390.817 145.058 388.516 136.557 394.174 134.174C389.716 133.66 376.026 134.409 373.572 128.29C371.117 122.172 380.638 121.224 383.878 123.535C382.849 120.168 387.036 115.205 394.563 119.717C402.089 124.229 401.999 129.798 401.295 131.449C404.652 132.351 405.311 139.824 401.602 140.825C403.777 143.84 401.899 150.175 396.034 148.821C395.835 152.512 391.72 150.897 391.973 148.063C392.225 145.229 393.624 145.004 393.624 145.004Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M381.116 146.637C381.91 146.869 382.747 146.908 383.559 146.751C384.37 146.594 385.132 146.246 385.782 145.735C385.816 145.699 385.834 145.653 385.834 145.604C385.834 145.555 385.816 145.508 385.782 145.473C385.748 145.44 385.703 145.421 385.656 145.421C385.608 145.421 385.563 145.44 385.529 145.473C384.929 145.954 384.224 146.286 383.472 146.443C382.719 146.6 381.94 146.577 381.198 146.375C381.175 146.369 381.151 146.367 381.128 146.369C381.105 146.372 381.082 146.38 381.062 146.392C381.041 146.403 381.024 146.419 381.01 146.438C380.996 146.457 380.986 146.479 380.981 146.502C380.988 146.535 381.004 146.566 381.028 146.59C381.052 146.614 381.083 146.631 381.116 146.637Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M397.532 147.495C396.235 148.705 394.512 149.353 392.74 149.299C390.393 149.2 389.942 146.926 391.196 145.094C392.334 143.443 394.915 141.484 396.972 142.486C397.42 142.71 397.804 143.043 398.09 143.454C398.376 143.865 398.556 144.341 398.611 144.838C398.667 145.336 398.597 145.84 398.409 146.303C398.22 146.767 397.919 147.177 397.532 147.495Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M348.068 377.609L359.8 380.38C359.8 380.38 363.952 334.671 367.516 309.556C368.464 302.896 369.926 293.529 372.155 283.547C374.961 270.976 378.472 257.376 381.378 246.728C384.419 235.51 386.738 227.578 386.738 227.578L361.849 225.836C361.849 225.836 348.375 284.585 346.949 306.154C345.424 328.661 348.068 377.609 348.068 377.609Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M372.092 283.547C374.899 270.976 378.409 257.376 381.315 246.727L378.725 241.159C372.579 248.496 370.919 271.211 372.092 283.547Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M375.241 226.774C375.241 226.774 377.949 287.527 380.927 308.103C384.203 330.664 392.532 379.884 392.532 379.884H405.536C405.536 379.884 401.927 333.074 399.481 311.009C396.692 285.876 399.67 228.48 399.67 228.48L375.241 226.774Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M390.98 380.163H406.285L406.962 375.588L390.068 375.29L390.98 380.163Z",
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M347.319 378.395L360.648 380.903L362.155 376.256L346.958 373.377L347.319 378.395Z",
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M385.854 139.869C385.701 140.419 385.295 140.771 384.952 140.699C384.609 140.627 384.41 140.076 384.554 139.526C384.699 138.975 385.114 138.623 385.457 138.695C385.8 138.768 385.998 139.318 385.854 139.869Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M379.591 138.226C379.447 138.777 379.032 139.129 378.689 139.048C378.346 138.966 378.156 138.434 378.301 137.874C378.445 137.315 378.86 136.972 379.203 137.044C379.546 137.116 379.736 137.667 379.591 138.226Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M380.981 138.741C379.873 140.258 378.565 141.618 377.091 142.784C377.822 143.948 379.708 143.849 379.708 143.849L380.981 138.741Z",
					fill: "#F0A460"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M387.794 138.073C387.731 138.069 387.671 138.048 387.62 138.011C387.569 137.974 387.529 137.924 387.505 137.866C387.353 137.471 387.11 137.118 386.797 136.835C386.483 136.551 386.108 136.345 385.7 136.232C385.657 136.224 385.616 136.207 385.579 136.183C385.542 136.159 385.511 136.127 385.486 136.091C385.461 136.055 385.444 136.014 385.435 135.97C385.426 135.927 385.426 135.883 385.434 135.84C385.443 135.796 385.459 135.755 385.483 135.718C385.508 135.682 385.539 135.65 385.575 135.625C385.612 135.6 385.653 135.583 385.696 135.574C385.739 135.565 385.784 135.565 385.827 135.573C386.344 135.705 386.822 135.959 387.221 136.314C387.62 136.669 387.928 137.114 388.119 137.613C388.137 137.654 388.146 137.698 388.147 137.742C388.147 137.787 388.139 137.831 388.122 137.872C388.105 137.913 388.08 137.951 388.049 137.982C388.017 138.014 387.98 138.038 387.939 138.055C387.892 138.072 387.843 138.078 387.794 138.073Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M376.947 135.086C376.877 135.078 376.811 135.05 376.757 135.005C376.725 134.973 376.7 134.936 376.682 134.895C376.665 134.854 376.656 134.81 376.656 134.765C376.656 134.721 376.665 134.677 376.682 134.636C376.7 134.595 376.725 134.557 376.757 134.526C377.095 134.113 377.527 133.787 378.017 133.575C378.507 133.363 379.04 133.271 379.573 133.308C379.66 133.323 379.738 133.371 379.791 133.441C379.844 133.511 379.87 133.599 379.861 133.687C379.848 133.775 379.801 133.854 379.73 133.908C379.66 133.962 379.571 133.986 379.482 133.976C379.061 133.957 378.64 134.036 378.255 134.209C377.869 134.381 377.529 134.641 377.262 134.968C377.224 135.014 377.175 135.048 377.12 135.069C377.065 135.089 377.005 135.095 376.947 135.086Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M393.75 389.901C393.265 389.938 392.782 389.811 392.378 389.54C392.251 389.43 392.152 389.29 392.092 389.132C392.032 388.974 392.013 388.804 392.036 388.637C392.033 388.539 392.059 388.443 392.11 388.36C392.162 388.276 392.236 388.21 392.324 388.168C393.109 387.762 395.393 389.17 395.654 389.332C395.682 389.348 395.703 389.373 395.716 389.402C395.729 389.431 395.733 389.463 395.727 389.495C395.724 389.529 395.71 389.561 395.687 389.587C395.664 389.613 395.634 389.631 395.6 389.639C394.995 389.795 394.375 389.883 393.75 389.901ZM392.694 388.43C392.619 388.423 392.544 388.439 392.478 388.475C392.433 388.475 392.378 388.538 392.369 388.673C392.354 388.785 392.366 388.899 392.406 389.004C392.445 389.11 392.51 389.204 392.595 389.278C393.388 389.639 394.288 389.684 395.113 389.404C394.375 388.925 393.55 388.594 392.685 388.43H392.694Z",
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M395.555 389.648H395.474C394.743 389.251 393.317 387.69 393.47 386.941C393.495 386.817 393.562 386.706 393.658 386.625C393.755 386.545 393.877 386.5 394.003 386.498C394.132 386.48 394.263 386.49 394.388 386.528C394.512 386.565 394.627 386.629 394.725 386.715C395.546 387.383 395.718 389.422 395.727 389.522C395.727 389.552 395.72 389.582 395.706 389.609C395.691 389.636 395.671 389.658 395.645 389.675C395.613 389.676 395.582 389.666 395.555 389.648ZM394.12 386.769H394.048C393.831 386.769 393.813 386.896 393.804 386.941C393.714 387.401 394.617 388.583 395.348 389.134C395.3 388.325 395.007 387.551 394.508 386.914C394.401 386.82 394.263 386.769 394.12 386.769Z",
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M349.143 387.672C347.979 387.672 345.93 387.626 345.281 386.823C345.178 386.7 345.108 386.552 345.078 386.394C345.048 386.236 345.059 386.073 345.109 385.921C345.129 385.832 345.17 385.75 345.23 385.682C345.29 385.614 345.367 385.563 345.452 385.533C346.354 385.217 348.954 387.112 349.242 387.338C349.27 387.357 349.291 387.386 349.3 387.419C349.31 387.451 349.309 387.486 349.296 387.518C349.292 387.557 349.275 387.594 349.247 387.622C349.219 387.65 349.182 387.668 349.143 387.672ZM345.587 385.867C345.552 385.878 345.52 385.9 345.496 385.928C345.472 385.957 345.457 385.992 345.452 386.029C345.423 386.124 345.417 386.225 345.436 386.322C345.455 386.42 345.498 386.511 345.56 386.589C345.921 387.049 347.058 387.311 348.647 387.32C347.573 386.616 346.129 385.758 345.587 385.876V385.867Z",
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M349.143 387.672C349.102 387.688 349.057 387.688 349.017 387.672C348.241 387.148 346.833 385.343 347.094 384.576C347.158 384.396 347.329 384.188 347.789 384.215C347.962 384.223 348.132 384.266 348.287 384.342C348.442 384.418 348.58 384.526 348.692 384.658C349.459 385.56 349.324 387.464 349.315 387.545C349.313 387.574 349.303 387.601 349.288 387.625C349.272 387.649 349.25 387.668 349.224 387.681L349.143 387.672ZM347.573 384.54C347.446 384.54 347.419 384.63 347.41 384.658C347.257 385.118 348.186 386.508 348.954 387.166C349.017 386.358 348.824 385.549 348.403 384.856C348.325 384.762 348.229 384.685 348.12 384.629C348.012 384.573 347.893 384.54 347.771 384.531C347.705 384.519 347.637 384.522 347.573 384.54Z",
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M373.996 198.781L371.117 196.723L323.919 262.791L326.798 264.849C335.57 270.792 346.318 273.071 356.747 271.2C367.176 269.329 376.461 263.456 382.62 254.834C388.779 246.213 391.325 235.525 389.714 225.053C388.102 214.58 382.462 205.152 373.996 198.781Z",
					fill: "#FDD400"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .1,
					d: "M373.996 198.781L371.117 196.723L323.919 262.791L326.798 264.849C335.57 270.792 346.318 273.071 356.747 271.2C367.176 269.329 376.461 263.456 382.62 254.834C388.779 246.213 391.325 235.525 389.714 225.053C388.102 214.58 382.462 205.152 373.996 198.781Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M304.092 234.924C303.42 229.341 303.834 223.681 305.311 218.255L306.213 218.49C304.763 223.806 304.358 229.354 305.022 234.824L304.092 234.924Z",
					fill: "#FDD400"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M306.827 245.816C306.022 243.762 305.373 241.65 304.887 239.499L305.789 239.3C306.27 241.402 306.907 243.465 307.693 245.473L306.827 245.816Z",
					fill: "#FDD400"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M355.723 269.502C377.68 264.979 391.814 243.512 387.29 221.555C382.767 199.598 361.301 185.464 339.343 189.988C317.386 194.511 303.253 215.977 307.776 237.935C312.299 259.892 333.766 274.025 355.723 269.502Z",
					fill: "#FDD400"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M356.384 220.411C350.055 216.757 341.961 218.926 338.307 225.255C334.652 231.585 336.821 239.679 343.151 243.333C346.036 244.999 349.283 245.455 352.315 244.859L353.1 248.854C349.139 249.633 344.885 249.037 341.115 246.86C332.837 242.081 330.001 231.497 334.78 223.219C339.559 214.942 350.143 212.106 358.42 216.885C362.191 219.062 364.835 222.448 366.141 226.267L362.288 227.585C361.288 224.662 359.27 222.077 356.384 220.411Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M349.904 229.6L332.272 219.42L334.308 215.894L351.94 226.074L349.904 229.6Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M342.306 234.617L328.2 226.473L330.236 222.947L344.342 231.091L342.306 234.617Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .1,
					d: "M380.403 226.377C378.514 218.175 373.567 211.002 366.572 206.32C359.577 201.638 351.059 199.801 342.756 201.182C334.453 202.563 326.989 207.058 321.886 213.752C316.782 220.446 314.424 228.834 315.291 237.207C314.278 232.808 314.176 228.249 314.992 223.81C315.808 219.37 317.524 215.145 320.034 211.394C322.545 207.643 325.796 204.446 329.589 201.999C333.382 199.552 337.636 197.908 342.088 197.167C346.541 196.427 351.098 196.606 355.479 197.693C359.859 198.78 363.971 200.753 367.56 203.489C371.15 206.226 374.141 209.668 376.35 213.605C378.559 217.541 379.938 221.888 380.403 226.377Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M407.097 170.967C408 172.113 408.749 173.142 409.507 174.261C410.265 175.38 411.005 176.454 411.727 177.573C413.162 179.811 414.524 182.085 415.788 184.459C417.051 186.832 418.224 189.26 419.289 191.768L420.065 193.673L420.769 195.631C421.004 196.272 421.203 196.958 421.41 197.625L421.708 198.636L421.789 198.889L421.924 199.439C422.01 199.814 422.071 200.194 422.105 200.576C422.191 201.848 422.022 203.125 421.609 204.331C421.297 205.238 420.888 206.109 420.39 206.93C419.567 208.272 418.611 209.53 417.539 210.684C415.635 212.707 413.567 214.569 411.357 216.252C407.154 219.461 402.679 222.296 397.983 224.726L395.059 220.268C398.84 217.046 402.621 213.653 406.041 210.214C407.703 208.568 409.247 206.807 410.662 204.944C411.263 204.166 411.783 203.328 412.214 202.444C412.347 202.155 412.45 201.853 412.521 201.542C412.521 201.343 412.521 201.307 412.521 201.542C412.508 201.607 412.508 201.675 412.521 201.74C412.519 201.768 412.519 201.795 412.521 201.822L412.44 201.623L412.124 200.829C411.907 200.288 411.718 199.755 411.465 199.223L410.743 197.625L409.976 196.028C408.902 193.907 407.756 191.796 406.511 189.711C405.265 187.626 403.975 185.551 402.63 183.511C401.971 182.482 401.285 181.462 400.6 180.461L398.542 177.528L407.097 170.967Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M406.187 167.087C412.838 168.431 418.677 184.693 418.677 184.693L404.797 196.001C404.797 196.001 400.285 187.735 396.603 179.757C392.641 171.066 398.128 165.462 406.187 167.087Z",
					fill: "#0066CC"
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .3,
					children: /* @__PURE__ */ _jsx("path", {
						opacity: .3,
						d: "M406.187 167.087C412.838 168.431 418.677 184.693 418.677 184.693L404.797 196.001C404.797 196.001 400.285 187.735 396.603 179.757C392.641 171.066 398.128 165.462 406.187 167.087Z",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M396.702 219.645L389.536 220.43L394.184 228.209C394.184 228.209 400.14 226.188 399.418 222.921L396.702 219.645Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M385.268 224.536L389.41 230.79L394.184 228.209L389.536 220.43L385.268 224.536Z",
					fill: "#FFB573"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 536.193,
				height: 400,
				fill: "white",
				transform: "translate(0.797852)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgStep5);
export default ForwardRef;
